import React from "react";
import Snippet from "../SnippetIcon/Snippet";
import SpecialText from "../Typography/SpecialText";
import InlineError from "../InlineError/InlineError";
import {
  FIELD_DEFAULT_VARIANT,
  FIELD_PAGE_TEXTAREA,
  FIELD_PAGE_TEXTAREA_FULL,
  INPUT_FIELD_VARIANT_CLASSES,
  resolveFieldVariant,
} from "./fieldSystem";

/** Long-text textarea variants → Page Field (spec §6) */
const PAGE_TEXTAREA_VARIANTS = new Set([
  "page",
  "large",
  "2xl",
  "general",
  "default",
]);

const PAGE_TEXTAREA_FULL_VARIANTS = new Set([
  "pageFull",
  "fullPage",
  "full",
]);

const resolveTextAreaClass = (variant, fullWidth = false) => {
  const resolved = resolveFieldVariant(variant, fullWidth);

  if (resolved === "upload" || resolved === "uploadFull") {
    return INPUT_FIELD_VARIANT_CLASSES[resolved === "uploadFull" ? "uploadFull" : "upload"];
  }
  if (
    resolved === FIELD_DEFAULT_VARIANT.textarea ||
    PAGE_TEXTAREA_VARIANTS.has(resolved) ||
    PAGE_TEXTAREA_FULL_VARIANTS.has(resolved)
  ) {
    return fullWidth || PAGE_TEXTAREA_FULL_VARIANTS.has(resolved)
      ? FIELD_PAGE_TEXTAREA_FULL
      : FIELD_PAGE_TEXTAREA;
  }
  return INPUT_FIELD_VARIANT_CLASSES[resolved] ?? FIELD_PAGE_TEXTAREA;
};

const TextArea = ({
  className = "",
  label,
  placeholder,
  variant = FIELD_DEFAULT_VARIANT.textarea,
  fullWidth = false,
  snippet,
  star,
  SnippetText,
  limitation,
  letterCounter,
  maxCount,
  error,
  ...restProps
}) => {
  const merged = `${resolveTextAreaClass(variant, fullWidth)} ${className}`.trim();

  return (
    <div className="flex w-full min-w-0 flex-col">
      {(label ||
        SnippetText ||
        snippet ||
        star ||
        (limitation && letterCounter && maxCount)) && (
        <div className="flex items-center justify-between">
          <Snippet
            variant={"label"}
            label={label}
            text={SnippetText}
            snippet={snippet}
            star={star}
          />
          {limitation && (
            <SpecialText variant={"Counter"}>
              {letterCounter}/{maxCount}
            </SpecialText>
          )}
        </div>
      )}
      <textarea
        {...restProps}
        name={restProps?.name}
        placeholder={placeholder}
        className={merged}
      />
      <InlineError message={error} />
    </div>
  );
};

export default TextArea;
